import * as zonesetting from './action-type';
import { formatAreaList } from 'Pages/ZoneSetting/events';

(() => {
	for (let key in zonesetting) {
		zonesetting[key] = `ZoneSetting/${zonesetting[key]}`;
	}
})();

let defaultState = {
	// 初始区域列表
	selectCard: [],
	selectedArea: {},
	areaList: [],
	newAreaList: [], //用于展示区域的数据
	previewData: [],
	batchSource: [], //批量设置表格dataSource
	currentBatchCell: {}, //当前操作的批量设置单元格
	formula: {
		showformula: {
			visible: false,
			value: ""
		}, //显示公式
		editformula: {
			visible: false,
			value: ""
		}, //编辑公式
		validateformula: {
			visible: false,
			value: ""
		}, //验证公式
		regionCode: [], //区域编码
		watermark:{
			visble:false,
			value:""
		},
		filetype:{
			visble:false,
			value:""
		}
	},
	zoneFormData: {},// 传递 区域 form 的区域值
	isSave: true, //模板是否保存
	validate: true, //保存模板是否校验通过
	isImplement: false, //实施态模板（从模板设置修改模板）
	areaVisible: {}, // 初始化 隐藏不显示属性
	showTabLaySetModal: false, //标签布局设置弹窗
	serverData: [],  // 后台返回的数据 只在初始化和保存时更新
	areaHide: {}, // 区域隐藏
	boxStatus: {
		showSide: false,
		isHighlight: false,
		reset: false
	},
	metaTreeNodes: [], //设置选中的元数据树节点
	leftSiderShow: true, //左栏显隐
	ismobile: false, //是否是移动模板
	isreport: false, //是否是报表模板
};
// 首页表单数据
export const zoneSettingData = (state = defaultState, action = {}) => {
	switch (action.type) {
		case zonesetting.ZONESETTING:
			return { ...state, ...{ zoneArray: action.data } };
		case zonesetting.UPDATESELECTCARD:
			return { ...state, ...{ selectCard: action.selectCard } };
		case zonesetting.UPDATEAREALIST:
			return {
				...state, ...{
					areaList: action.areaList,
					isSave: action.init,
					newAreaList: formatAreaList(action.areaList, state.zoneFormData && state.zoneFormData.headcode)
				}
			};
		case zonesetting.UPDATESELECTAREA:
			return { ...state, ...{ selectedArea: action.selectedArea } };
		case zonesetting.PREVIEWDATA:
			return { ...state, ...{ previewData: action.previewData } };
		case zonesetting.CLEARDATA:
			return {
				...state,
				...defaultState
			};
		case zonesetting.TOGGLEFORMULA:
			return { ...state, ...{ formula: { ...state.formula, ...action.formula } } }
		case zonesetting.SETFORMULAINFO:
			return { ...state, ...{ formula: { ...state.formula, ...action.formulaInfo } } }

		case zonesetting.UPDATEBATCHSOURCE:
			return { ...state, ...{ batchSource: action.batchSource } }
		case zonesetting.SETCURRENTBATCHCELL:
			return { ...state, ...{ currentBatchCell: action.currentBatchCell } }
		case zonesetting.SETZONEFORMFUN:
			return { ...state, ...{ zoneFormData: action.getFromData } }
		case zonesetting.UPDATESAVEFLAG:
			return { ...state, ...{ isSave: action.isSave } }
		case zonesetting.SETAREAVALIDATE:
			return { ...state, ...{ validate: action.validate } }
		case zonesetting.SETIMPLEMENTFLAG:
			return { ...state, ...{ isImplement: action.isImplement } }
		case zonesetting.SETAREAVISIBLE:
			return { ...state, ...{ areaVisible: action.areaVisible } }
		case zonesetting.TABLAYMODALVISIBLE:
			return { ...state, ...{ showTabLaySetModal: action.showTabLaySetModal } }
		case zonesetting.SETSEVERDATA:
			return { ...state, ...{ serverData: action.serverData } }
		case zonesetting.SETAREAHIDE:
			return { ...state, ...{ areaHide: action.areaHide } }
		case zonesetting.UPDATE_SEARCH_BOX:
			return { ...state, ...{ boxStatus: action.boxStatus } }
		case zonesetting.SET_META_TREE_NODES:
			return { ...state, metaTreeNodes: action.data };
		case zonesetting.ONTOGGLELEFTSIDER:
			return { ...state, leftSiderShow: action.leftSiderShow };
		case zonesetting.SETMOBILEFLAG:
			return { ...state, ismobile: action.ismobile };
		case zonesetting.SETREPORTFLAG:
			return { ...state, isreport: action.isreport };
		default:
			return state;
	}
};
